import React from 'react';
import Report from './containers/Report';

export default [
    {
        path: '/marketing',
        exact: true,
        component: () => <Report />
    },
];